import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AppShell from '../components/AppShell';

/** 資料刪除指示（Meta App → Live 要求；＋WhatsApp 官方要求嘅 deletion instructions URL） */
export default function DataDeletionPage() {
  const { t } = useTranslation();
  return (
    <AppShell title={t('deletion_title')}>
      <div className="p-6 max-w-2xl mx-auto text-sm leading-relaxed">
        <h1 className="text-xl font-bold mb-1">{t('deletion_title')}</h1>
        <p className="mb-5 text-xs" style={{ color: 'var(--color-text-secondary)' }}>
          {t('legal_updated')}
        </p>
        <p className="mb-5" style={{ color: 'var(--color-text-secondary)' }}>
          {t('deletion_intro')}
        </p>
        <section className="mb-5">
          <h2 className="font-semibold mb-1">{t('deletion_how_h')}</h2>
          <ol className="list-decimal pl-5 space-y-1" style={{ color: 'var(--color-text-secondary)' }}>
            <li>{t('deletion_step_1')}</li>
            <li>{t('deletion_step_2')}</li>
            <li>{t('deletion_step_3')}</li>
          </ol>
        </section>
        <section className="mb-5">
          <h2 className="font-semibold mb-1">{t('deletion_scope_h')}</h2>
          <p style={{ color: 'var(--color-text-secondary)' }}>{t('deletion_scope')}</p>
        </section>
        <section className="mb-5">
          <h2 className="font-semibold mb-1">{t('privacy_contact_h')}</h2>
          <p style={{ color: 'var(--color-text-secondary)' }}>{t('deletion_contact')}</p>
        </section>
        <div className="mt-8 flex flex-wrap gap-4">
          <Link to="/privacy" style={{ color: 'var(--color-primary)' }}>
            {t('footer_privacy')}
          </Link>
          <Link to="/" style={{ color: 'var(--color-primary)' }}>
            {t('back_home')}
          </Link>
        </div>
      </div>
    </AppShell>
  );
}
